<template>
  <!-- Authenticated: quick access grid -->
  <section class="access-section" v-if="auth">
    <div class="section-container">
      <div class="section-label">وصول سريع</div>
      <h2 class="section-title">ماذا تريد اليوم؟</h2>
      <div class="access-grid">
        <router-link to="/contents" class="access-card ac-lessons">
          <div class="ac-glow"></div>
          <div class="ac-icon">📚</div>
          <h3>محتوى الحصص</h3>
          <p>فيديوهات، ملفات PDF، وتسجيلات صوتية</p>
          <div class="ac-arrow">←</div>
        </router-link>
        <router-link to="/exams?type=online" class="access-card ac-exams">
          <div class="ac-glow"></div>
          <div class="ac-icon">📝</div>
          <h3>الامتحانات</h3>
          <p>امتحانات أونلاين مع نتائج فورية</p>
          <div class="ac-arrow">←</div>
        </router-link>
        <router-link to="/exams?type=homework" class="access-card ac-hw">
          <div class="ac-glow"></div>
          <div class="ac-icon">🏠</div>
          <h3>الواجب المنزلي</h3>
          <p>واجباتك الدراسية والتدريبات</p>
          <div class="ac-arrow">←</div>
        </router-link>
        <router-link to="/my_exams" class="access-card ac-results">
          <div class="ac-glow"></div>
          <div class="ac-icon">📊</div>
          <h3>نتائجي</h3>
          <p>تابع تقدمك ومراجعة إجاباتك</p>
          <div class="ac-arrow">←</div>
        </router-link>
      </div>
    </div>
  </section>

  <!-- Guest: features grid -->
  <section class="features-section" v-else>
    <div class="section-container">
      <div class="section-label">لماذا منصتنا؟</div>
      <h2 class="section-title">كل ما يحتاجه الطالب في مكان واحد</h2>
      <div class="features-grid">
        <div class="feature-card">
          <div class="fc-icon-wrap fc-purple">🎬</div>
          <h3>دروس فيديو احترافية</h3>
          <p>شرح واضح ومبسط بجودة عالية لجميع المناهج الدراسية</p>
        </div>
        <div class="feature-card">
          <div class="fc-icon-wrap fc-blue">📝</div>
          <h3>امتحانات تفاعلية</h3>
          <p>اختبارات أونلاين مع تصحيح فوري ومراجعة تفصيلية للإجابات</p>
        </div>
        <div class="feature-card">
          <div class="fc-icon-wrap fc-green">📊</div>
          <h3>متابعة التقدم</h3>
          <p>تتبع أداءك واطلع على نتائجك وتحليل نقاط قوتك وضعفك</p>
        </div>
        <div class="feature-card">
          <div class="fc-icon-wrap fc-orange">💬</div>
          <h3>دعم مستمر</h3>
          <p>تواصل مباشر مع الأستاذ وإجابة على كل استفساراتك</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
defineProps({ auth: { type: Boolean, default: false } });
</script>

<style scoped>
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.section-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}
.section-label {
  display: inline-block;
  background: rgba(212, 175, 55, 0.08);
  color: #D4AF37;
  border: 1px solid rgba(212, 175, 55, 0.2);
  border-radius: 99px;
  padding: 0.3rem 1rem;
  font-size: 0.8rem;
  font-weight: 700;
  margin-bottom: 1rem;
}
.section-title {
  font-size: clamp(1.6rem, 3vw, 2.2rem);
  font-weight: 800;
  color: #F0EDE4;
  margin-bottom: 2.5rem;
  line-height: 1.3;
}

.access-section,
.features-section {
  padding: 6rem 0;
  background: #111111;
}

/* Quick access cards */
.access-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
}
@media (min-width: 900px) {
  .access-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

.access-card {
  position: relative;
  overflow: hidden;
  border-radius: 24px;
  padding: 2rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  text-decoration: none;
  color: #fff;
  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.35s;
  cursor: pointer;
  @media (max-width: 800px) {
    padding: 1rem 1rem;
  }
}
.access-card:hover {
  transform: translateY(-8px) scale(1.02);
  color: #fff;
}
.access-card:hover .ac-glow {
  opacity: 1;
}
.ac-lessons {
  background: linear-gradient(135deg, #D4AF37 0%, #C89B2D 100%);
  box-shadow: 0 20px 50px rgba(212, 175, 55, 0.3);
}
.ac-exams {
  background: linear-gradient(135deg, #C89B2D 0%, #D4AF37 100%);
  box-shadow: 0 20px 50px rgba(212, 175, 55, 0.25);
}
.ac-hw {
  background: linear-gradient(135deg, #B8860B 0%, #D4AF37 100%);
  box-shadow: 0 20px 50px rgba(212, 175, 55, 0.2);
}
.ac-results {
  background: linear-gradient(135deg, #f59e0b 0%, #ef4444 100%);
  box-shadow: 0 20px 50px rgba(245, 158, 11, 0.25);
}
.ac-glow {
  position: absolute;
  inset: 0;
  opacity: 0;
  background: rgba(255, 255, 255, 0.08);
  transition: opacity 0.3s;
  border-radius: inherit;
}
.ac-icon {
  font-size: 2.5rem;
}
.access-card h3 {
  font-size: 1.2rem;
  font-weight: 800;
  margin: 0;
}
.access-card p {
  font-size: 0.88rem;
  opacity: 0.88;
  margin: 0;
  line-height: 1.5;
}
.ac-arrow {
  font-size: 1.2rem;
  margin-top: auto;
  opacity: 0.6;
  transition: transform 0.25s, opacity 0.25s;
}
.access-card:hover .ac-arrow {
  transform: translateX(-6px);
  opacity: 1;
}

/* Feature cards */
.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 1.5rem;
}
.feature-card {
  background: #1A1A1A;
  border-radius: 20px;
  padding: 2rem 1.5rem;
  border: 1px solid rgba(212, 175, 55, 0.12);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}
.feature-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 20px 50px rgba(212, 175, 55, 0.12);
  border-color: rgba(212, 175, 55, 0.2);
}
.fc-icon-wrap {
  width: 56px;
  height: 56px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.6rem;
}
.fc-purple {
  background: linear-gradient(
    135deg,
    rgba(212, 175, 55, 0.1),
    rgba(212, 175, 55, 0.1)
  );
}
.fc-blue {
  background: linear-gradient(
    135deg,
    rgba(212, 175, 55, 0.12),
    rgba(200, 155, 45, 0.08)
  );
}
.fc-green {
  background: linear-gradient(
    135deg,
    rgba(184, 134, 11, 0.12),
    rgba(212, 175, 55, 0.08)
  );
}
.fc-orange {
  background: linear-gradient(
    135deg,
    rgba(245, 158, 11, 0.1),
    rgba(239, 68, 68, 0.1)
  );
}
.feature-card h3 {
  font-size: 1.05rem;
  font-weight: 700;
  color: #F0EDE4;
}
.feature-card p {
  font-size: 0.88rem;
  color: rgba(240, 237, 228, 0.6);
  line-height: 1.7;
}

@media (max-width: 600px) {
  .access-grid {
    grid-template-columns: 1fr 1fr;
  }
}
</style>
